import { Funnel, ListPlus, RemoveFormatting, Wrench } from "lucide-react"
import { DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui"

import Utilities from "../Utilities"

import AddProps from "./Add"
import FilterProps from "./Filter"
import ResetProps from "./Reset"
import { ToolbarProvider, useToolbar } from "./context"

export default function ToolbarWrapper(props) {
  return <ToolbarProvider>
    <ToolbarSidebar {...props} />
  </ToolbarProvider>
}

const ToolbarSidebar = ({ properties, resetProps }) => {
  const { toolbar = [] } = useToolbar()

  return <ToggleOptionGroup type='multiple' className='mx-2 px-1 py-px' value={toolbar}>
    <Item
      icon={Wrench}
      tooltip='Utilities'
      value='utilities'
      wrapper={Utilities} />
    <Item
      icon={ListPlus}
      tooltip='Add properties'
      value='addProps'
      wrapper={AddProps}
      wrapperProps={{ ...properties }}
      disabled={toolbar.includes('filterProps')}
    />
    <Item
      icon={RemoveFormatting}
      tooltip='Reset properties'
      value='resetProps'
      wrapper={ResetProps}
      wrapperProps={{ ...resetProps }}
    />
    <Item
      icon={Funnel}
      tooltip={toolbar.includes('filterProps') ? 'Show all properties' : 'Filter only properties with values'}
      value='filterProps'
      wrapper={FilterProps}
    />
  </ToggleOptionGroup>
}

const Item = ({ icon: Icon, tooltip, value, wrapper: Wrapper, wrapperProps = {}, disabled }) => <>
  <ToggleOptionGroupItem disabled={disabled} value={value} className='w-full'>
    <DefaultTooltip content={tooltip} triggerProps={{ className: 'w-full flex justify-center' }}>
      <Wrapper {...wrapperProps} trigger={<div className='w-full h-full flex justify-center items-center'> <Icon size={14} /> </div>} />
    </DefaultTooltip>
  </ToggleOptionGroupItem>
</>

